import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Attach admin token when present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('enersider_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  bootstrap: () => client.get('/bootstrap').then((r) => r.data),
  // auth
  login: (email, password) => client.post('/auth/login', { email, password }).then((r) => r.data),
  me: () => client.get('/auth/me').then((r) => r.data),
  listUsers: () => client.get('/auth/users').then((r) => r.data),
  createUser: (body) => client.post('/auth/users', body).then((r) => r.data),
  deleteUser: (id) => client.delete(`/auth/users/${id}`).then((r) => r.data),
  // collections
  listCollection: (name) => client.get(`/admin/collections/${name}`).then((r) => r.data),
  importCollection: (name, file, mode) => { const fd = new FormData(); fd.append('file', file); fd.append('mode', mode); return client.post(`/admin/import/${name}`, fd).then((r) => r.data); },
  createItem: (name, body) => client.post(`/admin/collections/${name}`, body).then((r) => r.data),
  updateItem: (name, id, body) => client.put(`/admin/collections/${name}/${id}`, body).then((r) => r.data),
  deleteItem: (name, id) => client.delete(`/admin/collections/${name}/${id}`).then((r) => r.data),
  // singletons
  getSingleton: (name) => client.get(`/admin/singletons/${name}`).then((r) => r.data),
  putSingleton: (name, body) => client.put(`/admin/singletons/${name}`, body).then((r) => r.data),
  // wire
  listWire: (status) => client.get(`/admin/wire${status ? `?status=${status}` : ''}`).then((r) => r.data),
  fetchWire: () => client.post('/admin/wire/fetch').then((r) => r.data),
  addWire: (body) => client.post('/admin/wire', body).then((r) => r.data),
  updateWire: (id, body) => client.put(`/admin/wire/${id}`, body).then((r) => r.data),
  deleteWire: (id) => client.delete(`/admin/wire/${id}`).then((r) => r.data),
  reclassifyWire: () => client.post('/admin/wire/reclassify').then((r) => r.data),
  // sectors
  getSectors: () => client.get('/sectors').then((r) => r.data),
  getSectorRules: () => client.get('/admin/sector-rules').then((r) => r.data),
  putSectorRules: (rules) => client.put('/admin/sector-rules', { rules }).then((r) => r.data),
  // leads
  createLead: (body) => client.post('/leads', body).then((r) => r.data),
  listLeads: () => client.get('/admin/leads').then((r) => r.data),
  // chunked file upload -> returns { fileId, url }
  uploadFile: async (file, onProgress) => {
    const CHUNK = 4 * 1024 * 1024;
    const init = await client.post('/admin/upload/init', { filename: file.name });
    const uploadId = init.data.uploadId;
    const total = Math.max(1, Math.ceil(file.size / CHUNK));
    for (let i = 0; i < total; i++) {
      const blob = file.slice(i * CHUNK, (i + 1) * CHUNK);
      const fd = new FormData();
      fd.append('uploadId', uploadId);
      fd.append('index', i);
      fd.append('file', blob, file.name);
      await client.post('/admin/upload/chunk', fd);
      if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
    }
    const done = await client.post('/admin/upload/complete', {
      uploadId, filename: file.name, totalChunks: total, contentType: file.type || 'application/pdf',
    });
    // Store ENV-AGNOSTIC relative paths (e.g. /api/uploads/<id>). The browser resolves
    // them against the current origin, and ingress routes /api/* to the backend — so the
    // same record works in preview AND production without baking in a hostname.
    return { fileId: done.data.fileId, url: done.data.url, coverUrl: done.data.coverUrl || null };
  },
};

export default client;
